import type { PropRow } from './content';

interface PropsTableProps {
    rows: PropRow[];
}

const PropsTable = ({ rows }: PropsTableProps) => (
    <div className="props-table-wrap">
        <table className="props-table">
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Type</th>
                    <th>Description</th>
                </tr>
            </thead>
            <tbody>
                {rows.map((row) => (
                    <tr key={row.name}>
                        <td>
                            <code>{row.name}</code>
                        </td>
                        <td>
                            <code className="props-table-type">{row.type}</code>
                            {row.defaultValue ? <div className="props-table-default">default {row.defaultValue}</div> : null}
                        </td>
                        <td>{row.description}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    </div>
);

export default PropsTable;
